import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-private-message",
  "use": "svgIcon-private-message-usage",
  "viewBox": "0 0 29.617 27.186",
  "content": "<symbol viewBox=\"0 0 29.617 27.186\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-private-message\"><path d=\"m14.8 2.3c-8.2 0-14.8 5.1-14.8 11.4 0 2.9 1.4 5.5 3.7 7.5-.4 2.9-2.6 6-2.6 6s4.7-1.2 6.8-3.4c2.1.8 4.4 1.3 6.9 1.3 8.2 0 14.8-5.1 14.8-11.4s-6.6-11.4-14.8-11.4m-6.3 13.8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m6.8 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m6.8 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol